import { createFindById, createFindByIdThrows } from '../findById';

export const findById = createFindById('groupLinks');
export const findByIdThrows = createFindByIdThrows('groupLinks');
